import { defineComponent as _defineComponent } from 'vue'
import { createTextVNode as _createTextVNode, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, unref as _unref, resolveComponent as _resolveComponent, withModifiers as _withModifiers, withKeys as _withKeys, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "cmi00310-form-area cmi00310-form" }
const _hoisted_2 = { class: "cmi00310-input-area q-gutter-y-sm" }
const _hoisted_3 = { class: "flex justify-center" }
const _hoisted_4 = { class: "left-input-area" }
const _hoisted_5 = { class: "q-mb-none q-ml-sm q-mt-sm" }
const _hoisted_6 = { class: "flex justify-center" }
const _hoisted_7 = { class: "left-input-area" }
const _hoisted_8 = { class: "q-mb-none q-ml-sm q-mt-sm" }
const _hoisted_9 = { class: "flex justify-center" }
const _hoisted_10 = { class: "left-input-area" }
const _hoisted_11 = { class: "q-mb-none q-ml-sm q-mt-sm" }
const _hoisted_12 = { class: "row justify-end" }

import axios from 'axios';
import Loading from 'quasar/src/plugins/Loading.js';;
import { reactive, ref } from 'vue';
import { useRouter } from 'vue-router';
import ResultStatusCode from '../../common/code/ResultStatusCode';
import AlertDialog from '../../components/dialogs/AlertDialog.vue';
import HttpResponseStatusCode from '../../common/code/HttpResponseStatusCode';
import { isEmpty, isTwoDecimalPlaces, isDecimalDigits } from '../../common/utils/validateUtils';
import PageHeaderBanner from '../../components/banner/PageHeaderBanner.vue';
import FormFooterBanner from '../../components/banner/FormFooterBanner.vue';
import DetailResultStatusCode from '../../common/code/DetailResultStatusCode';


export default /*@__PURE__*/_defineComponent({
  __name: 'CMD01100',
  setup(__props) {

const router = useRouter();
// Dialogタイトル
const dialogTitle = ref('');
// Dialog本文
const dialogText = ref(['']);
// 更新確認ダイアログ表示フラグ
const isConfirmationFlg = ref(false);
// 更新完了ダイアログ表示フラグ
const isUpdatedDisplayFlg = ref(false);
// 更新成功フラグ
const isUpdatedFlg = ref(false);
// エラーDialog表示フラグ
const uploadErrorFLg = ref(false);
// 初期表示データ
const initData = reactive({
  dollar_exchange_rate: '',
  euro_exchange_rate: '',
  pound_exchange_rate: '',
  dollar_update_timestamp: '',
  euro_update_timestamp: '',
  pound_update_timestamp: '',
  currency_code: '',
});

// 入力データ
const inputData = ref({ ...initData });

/**
 * 為替レートを初期化
 */
const initRate = () => {
  inputData.value = { ...initData };
};

/**
 * 為替レート取得
 */
const showRate = async () => {
  // Loading Start
  Loading.show();

  // 為替レート取得
  await axios
    .post('/cmd011001/showRate')
    .then((res) => {
      const { common, getCurrencyRateList } = res.data;

      switch (common.status) {
        // 正常終了の場合
        case ResultStatusCode.SUCCESS:
          getCurrencyRateList.forEach(
            (value: { currency_code: string; exchange_rate: string; update_timestamp: string }) => {
              if (value.currency_code === 'EUR') {
                initData.euro_exchange_rate = value.exchange_rate;
                initData.euro_update_timestamp = value.update_timestamp;
              } else if (value.currency_code === 'USD') {
                initData.dollar_exchange_rate = value.exchange_rate;
                initData.dollar_update_timestamp = value.update_timestamp;
              } else if (value.currency_code === 'GBP') {
                initData.pound_exchange_rate = value.exchange_rate;
                initData.pound_update_timestamp = value.update_timestamp;
              }
            }
          );
          inputData.value = { ...initData };
          break;
        // エラーの場合
        case ResultStatusCode.ERROR:
          if (res.data.common.detail_status === DetailResultStatusCode.PARAMETER_ERROR) {
            dialogTitle.value = '検索条件入力エラー';
            dialogText.value = [res.data.message];
            uploadErrorFLg.value = true;
          } else {
            router.push({ name: 'error' });
          }

          break;
        default:
          router.push({ name: 'error' });
      }
    })
    .catch((err) => {
      if (err.res.status === HttpResponseStatusCode.SESSIONTIMEOUT) {
        // セッションタイムアウトの場合
        router.push({ name: 'login', query: { timeout: 'timeout' } });
      } else {
        // その他エラーの場合
        router.push({ name: 'error' });
      }
    })
    .finally(() => {
      // Loading End
      Loading.hide();
    });
};

/**
 *  為替レート情報の更新
 */
const updateRate = async () => {
  // 係数の小数部を2桁に固定する
  inputData.value.dollar_exchange_rate = Number(inputData.value.dollar_exchange_rate).toFixed(2);
  inputData.value.euro_exchange_rate = Number(inputData.value.euro_exchange_rate).toFixed(2);
  inputData.value.pound_exchange_rate = Number(inputData.value.pound_exchange_rate).toFixed(2);

  isConfirmationFlg.value = false;
  isUpdatedDisplayFlg.value = false;
  // Loading Start
  Loading.show();
  // 変更用データ作成
  const formData = new FormData();
  formData.append('dollar_exchange_rate', inputData.value.dollar_exchange_rate);
  formData.append('euro_exchange_rate', inputData.value.euro_exchange_rate);
  formData.append('pound_exchange_rate', inputData.value.pound_exchange_rate);
  formData.append('old_dollar_exchange_rate', initData.dollar_exchange_rate);
  formData.append('old_euro_exchange_rate', initData.euro_exchange_rate);
  formData.append('old_pound_exchange_rate', initData.pound_exchange_rate);
  await axios
    .post('/cmd011001/editRate', formData)
    .then((res) => {
      const { common, getCurrencyRateList } = res.data;

      switch (common.status) {
        // 正常終了の場合
        case ResultStatusCode.SUCCESS:
          // 削除確認ダイアログのtitleを設定
          dialogTitle.value = '更新完了';
          // 削除確認ダイアログのtextを生成
          dialogText.value = ['為替レートが更新されました。'];
          isUpdatedDisplayFlg.value = true;
          isUpdatedFlg.value = true;
          getCurrencyRateList.forEach(
            (value: { currency_code: string; exchange_rate: string; update_timestamp: string }) => {
              if (value.currency_code === 'EUR') {
                initData.euro_exchange_rate = value.exchange_rate;
                initData.euro_update_timestamp = value.update_timestamp;
              } else if (value.currency_code === 'USD') {
                initData.dollar_exchange_rate = value.exchange_rate;
                initData.dollar_update_timestamp = value.update_timestamp;
              } else if (value.currency_code === 'GBP') {
                initData.pound_exchange_rate = value.exchange_rate;
                initData.pound_update_timestamp = value.update_timestamp;
              }
            }
          );
          inputData.value = { ...initData };
          break;
        // エラーの場合
        case ResultStatusCode.ERROR:
          if (res.data.common.detail_status === DetailResultStatusCode.PARAMETER_ERROR) {
            dialogTitle.value = '設定値入力エラー';
            dialogText.value = [res.data.common.message];
            uploadErrorFLg.value = true;
          } else {
            router.push({ name: 'error' });
          }

          break;
        default:
          router.push({ name: 'error' });
      }
    })
    .catch((err) => {
      if (err.response.status === HttpResponseStatusCode.SESSIONTIMEOUT) {
        // セッションタイムアウトの場合
        router.push({ name: 'login', query: { timeout: 'timeout' } });
      } else {
        // その他エラーの場合
        router.push({ name: 'error' });
      }
    })
    .finally(() => {
      // Loading End
      Loading.hide();
    });
};
// 初期表示
showRate();

return (_ctx: any,_cache: any) => {
  const _component_q_input = _resolveComponent("q-input")!
  const _component_q_btn = _resolveComponent("q-btn")!
  const _component_q_form = _resolveComponent("q-form")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createVNode(PageHeaderBanner, null, {
      title: _withCtx(() => _cache[11] || (_cache[11] = [
        _createTextVNode("為替レート設定")
      ])),
      _: 1
    }),
    _createVNode(_component_q_form, {
      autofocus: "",
      greedy: "",
      novalidate: "",
      onSubmit: _cache[10] || (_cache[10] = ($event: any) => (isConfirmationFlg.value = true))
    }, {
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_1, [
          _createElementVNode("div", _hoisted_2, [
            _createElementVNode("div", _hoisted_3, [
              _createElementVNode("div", _hoisted_4, [
                _cache[12] || (_cache[12] = _createElementVNode("label", { class: "requier" }, "USD / JPY", -1)),
                _createVNode(_component_q_input, {
                  modelValue: inputData.value.dollar_exchange_rate,
                  "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((inputData.value.dollar_exchange_rate) = $event)),
                  rules: [
                  (val) => _unref(isEmpty)(val) || _ctx.$t('validation.required'),
                  (val) => _unref(isDecimalDigits)(val) || _ctx.$t('validation.numeric_only'),
                  (val) => _unref(isTwoDecimalPlaces)(val) || _ctx.$t('validation.two_decimal_places'),
                  (val) => val < 1000 || _ctx.$t('validation.max_integer', { param1: '3' }),
                ],
                  outlined: "",
                  maxlength: "6",
                  dense: "",
                  suffix: "円",
                  "input-class": "text-right",
                  class: "input-area exception-right",
                  "lazy-rules": "",
                  onKeydown: _cache[1] || (_cache[1] = _withKeys(_withModifiers(() => {}, ["prevent"]), ["enter"]))
                }, null, 8, ["modelValue", "rules"])
              ]),
              _createElementVNode("div", null, [
                _cache[13] || (_cache[13] = _createElementVNode("label", null, "最終更新日時", -1)),
                _createElementVNode("p", _hoisted_5, _toDisplayString(inputData.value.dollar_update_timestamp), 1)
              ])
            ]),
            _createElementVNode("div", _hoisted_6, [
              _createElementVNode("div", _hoisted_7, [
                _cache[14] || (_cache[14] = _createElementVNode("label", { class: "requier" }, "EUR / JPY", -1)),
                _createVNode(_component_q_input, {
                  modelValue: inputData.value.euro_exchange_rate,
                  "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((inputData.value.euro_exchange_rate) = $event)),
                  rules: [
                  (val) => _unref(isEmpty)(val) || _ctx.$t('validation.required'),
                  (val) => _unref(isDecimalDigits)(val) || _ctx.$t('validation.numeric_only'),
                  (val) => _unref(isTwoDecimalPlaces)(val) || _ctx.$t('validation.two_decimal_places'),
                  (val) => val < 1000 || _ctx.$t('validation.max_integer', { param1: '3' }),
                ],
                  outlined: "",
                  maxlength: "6",
                  dense: "",
                  suffix: "円",
                  "input-class": "text-right",
                  class: "input-area exception-right",
                  "lazy-rules": "",
                  onKeydown: _cache[3] || (_cache[3] = _withKeys(_withModifiers(() => {}, ["prevent"]), ["enter"]))
                }, null, 8, ["modelValue", "rules"])
              ]),
              _createElementVNode("div", null, [
                _cache[15] || (_cache[15] = _createElementVNode("label", null, "最終更新日時", -1)),
                _createElementVNode("p", _hoisted_8, _toDisplayString(inputData.value.euro_update_timestamp), 1)
              ])
            ]),
            _createElementVNode("div", _hoisted_9, [
              _createElementVNode("div", _hoisted_10, [
                _cache[16] || (_cache[16] = _createElementVNode("label", { class: "requier" }, "GBP / JPY", -1)),
                _createVNode(_component_q_input, {
                  modelValue: inputData.value.pound_exchange_rate,
                  "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((inputData.value.pound_exchange_rate) = $event)),
                  rules: [
                  (val) => _unref(isEmpty)(val) || _ctx.$t('validation.required'),
                  (val) => _unref(isDecimalDigits)(val) || _ctx.$t('validation.numeric_only'),
                  (val) => _unref(isTwoDecimalPlaces)(val) || _ctx.$t('validation.two_decimal_places'),
                  (val) => val < 1000 || _ctx.$t('validation.max_integer', { param1: '3' }),
                ],
                  outlined: "",
                  maxlength: "6",
                  dense: "",
                  suffix: "円",
                  "input-class": "text-right",
                  class: "input-area exception-right",
                  "lazy-rules": "",
                  onKeydown: _cache[5] || (_cache[5] = _withKeys(_withModifiers(() => {}, ["prevent"]), ["enter"]))
                }, null, 8, ["modelValue", "rules"])
              ]),
              _createElementVNode("div", null, [
                _cache[17] || (_cache[17] = _createElementVNode("label", null, "最終更新日時", -1)),
                _createElementVNode("p", _hoisted_11, _toDisplayString(inputData.value.pound_update_timestamp), 1)
              ])
            ]),
            _createVNode(FormFooterBanner, { style: {"position":"inherit"} }, {
              "button-area": _withCtx(() => [
                _createElementVNode("div", _hoisted_12, [
                  _createVNode(_component_q_btn, {
                    color: "primary",
                    style: {"width":"130px"},
                    class: "q-mr-md",
                    label: "変更",
                    type: "submit"
                  }),
                  _createVNode(_component_q_btn, {
                    outline: "",
                    type: "reset",
                    style: {"width":"130px","background":"var(--q-white) !important","color":"var(--q-delete)"},
                    label: "リセット",
                    icon: "cached",
                    onClick: initRate
                  })
                ])
              ]),
              _: 1
            }),
            _createVNode(AlertDialog, {
              display: isConfirmationFlg.value,
              level: "information",
              title: '更新確認',
              text: ['入力された内容で更新します。', 'よろしいですか？'],
              onConfirm: _cache[6] || (_cache[6] = ($event: any) => (updateRate())),
              onClose: _cache[7] || (_cache[7] = ($event: any) => (isConfirmationFlg.value = false))
            }, null, 8, ["display"]),
            _createVNode(AlertDialog, {
              display: isUpdatedDisplayFlg.value,
              level: "information",
              confirmation: "",
              title: '更新完了',
              text: ['更新が完了しました。'],
              onComplete: _cache[8] || (_cache[8] = ($event: any) => (isUpdatedDisplayFlg.value = false))
            }, null, 8, ["display"]),
            _createVNode(AlertDialog, {
              display: uploadErrorFLg.value,
              level: "error",
              title: dialogTitle.value,
              text: dialogText.value,
              onComplete: _cache[9] || (_cache[9] = ($event: any) => (uploadErrorFLg.value = false))
            }, null, 8, ["display", "title", "text"])
          ])
        ])
      ]),
      _: 1
    })
  ]))
}
}

})